import React, { useState, useContext, useEffect, useMemo } from 'react'
import { Table, DatePicker, Select, Button, message, Modal, Form, Input, Tag, Space, Cascader,TreeSelect,Switch,Tooltip, Dropdown,Menu, Checkbox} from 'antd'
import { StateContext } from '../../../state';
import http from '../../../../../utils/server'
import { SearchOutlined ,SyncOutlined} from '@ant-design/icons';
import moment from 'moment';
import { Mode, Version } from '../../../../../App';
import audioSrc from '../../../../../../public/assets/warning.mp3'
import Sign from '../../../sign';
import './index.less'
const { RangePicker } = DatePicker;

function exportCsv(obj) {
    var title = obj.title;
    var titleForKey = Object.keys(obj.data[0]);
    var data = obj.data;
    var str = [];
    str.push(obj.title.join(",") + "\n");
    for (var i = 0; i < data.length; i++) {
        var temp = [];
        for (var j = 0; j < titleForKey.length; j++) {
            temp.push(data[i][titleForKey[j]]);
        }
        str.push(temp.join(",") + "\n");
    }
    var blob = new Blob(['\uFEFF' + str.join('')], {
        type: 'text/plain;charset=utf-8',
    });
    var downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "export.csv";
    downloadLink.click();
}

function findUserDis(nop, list, districts,userDis) {
    if (list&&districts) {
        const nops = list.filter(x => { return x.parent === nop })
        if (nops.length === 0) {
            return
        } else {
            for (var j = 0; j < nops.length; j++) {
                let tempDis=districts.filter(x=>x.user===nops[j].id);
                tempDis.length>0&&userDis.push(...tempDis);
                findUserDis(nops[j].id, list,districts,userDis);
            }
        }
    }
}
function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};
const alarmtype = [
    '设备电源断电报警',//0
    '设备电源恢复报警',//1
    '设备监测开门报警',//2
    '设备监测关门报警',//3
    '探头电源异常报警',//4
    '探头电源恢复正常',//5
    '探头监测开门报警',//6
    '探头监测关门报警',//7
    '探头连接失败报警',//8
    '探头连接恢复正常',//9
    '探头温度超上限报警',//10
    '探头温度恢复报警',//11
    '探头湿度超上限报警',//12
    '探头湿度恢复报警',//13
    '探头温度预警',//14
    '探头湿度预警',//15
    '探头压强超标报警',//16
    '探头压强恢复报警',//17
    '探头电量低报警',//18
    '设备离线恢复',//19
    '设备离线报警',//20
    '',//21
    '仪表传感器故障',//22
    '仪表传感器故障解除',//23
    '设备移动',//24
    '探头温度超下限报警',//25
    '探头湿度超下限报警',//26
]
const  showalarmtype=[0,2,4,6,8,10,12,14,15,16,18,20,22,24,25,26,27,29]


function Alarm(props) {
    const [form] = Form.useForm();
    const [isDash,setIsDash]  = useState(false);
    const { state, dispatch } = useContext(StateContext)
    const [selDeviceNodeIds, setSelDeviceNodeIds] = useState([]);//选择区域内同主机的测点
    const [selDeviceNodes, setSelDeviceNodes] = useState([]);//测点方式查询 选择的测点设备
    const [alarmDevOption, setAlarmDevOption] = useState([]);//区域内主机的选项
    const [selAlarmDev, setSelAlarmDev] = useState(undefined);//主机方式查询 选择的主机设备
    const [disNodes, setDisNodes] = useState([])//选择区域内的所有测点
    const [nodeFliters, setNodeFliters] = useState([])//所有测点
    const [devFliters, setDevFliters] = useState([])//所有主机
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [data, setData] = useState([]);//显示的报警数据
    const [dataSave, setDataSave] = useState([]);//保存查询的报警数据
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);//选中的关键值
    const [showDeal, setShowDeal] = useState(false);
    const [dealList, setDealList] = useState([]);
    const [showDealMsgBox, setShowDealMsgBox] = useState(false);
    const [showDealMsg, setShowDealMsg] = useState([]);
    const [showData, setShowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [defExpend,setDefExpend]=useState([]);//树默认展示列表
    const [selUser, setSelUser] = useState(0);//树选择的用户
    const [selUserDis, setSelUserDis] = useState([]);//用户关联的区域 用户为空选择全部区域
    const [alarmTypeOption, setAlarmTypeOption] = useState([]);
    const [selDis, setSelDis] = useState(undefined);//选择的区域
    const [selAlarmType, setSelAlarmType] = useState(undefined);//选择的类型
    const [closeInterval, setCloseInterval] = useState(false)
    const [selDev,setSelDev] = useState('');
    const [selNode,setSelNode] = useState('');
    const [showSgin,setShowSgin] = useState(false)
    const [mySgin,setMySgin] = useState('')
    const [sgin,setSgin] = useState('')
    const [sginEnable,setSginEnable] = useState(false)
    const [showAlarmDeal,setShowAlarmDeal] = useState(false)
    const [dealEnable,setDealEnable] = useState(false)
    const [isDealAlarmMore,setIsDealAlarmMore] = useState(false)
    const [electricList,setElectricList] = useState([]);
    const [isNewType,setIsNewType] = useState(false)
    let interval;
    function autoRefresh(checked) {
        if (checked) {
          setCloseInterval(false)
        } else {
          setCloseInterval(true)
        }
    }

    function getAlarmDataS(){
        setIsLoading(true);
        let audioEle = document.getElementById('audio');
        var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        // let isNewTypet = false;
        let url = "/v1/alarmby?" ;
        startTime === ''? url += "starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
        endTime===''? url+="starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
        url+="starttime=" + startTime + "&endtime=" + endTime;
        if(selUser!==0){
            url+=`&user=${selUser}`
        }
        if(selDis&&selDis!==''){
            url+=`&district=${selDis}`
        }
        
        if(selAlarmType!==undefined&&selAlarmType>=0){

            if(startTime===''||new Date(startTime)>=new Date('2026-02-01 00:00:00')){
                url+=`&alarmType=${selAlarmType%10000}`
                setIsNewType(false)
            }else{
                url+=`&alarmType=${selAlarmType%10000}&filter=true`
                // isNewTypet = true;
                setIsNewType(true)
            }
        }else{
            setIsNewType(false)
        }
        if(selAlarmDev&&selAlarmDev!==''){
            url+=`&device=${selAlarmDev}`
        }
        if(selDeviceNodeIds.length>0){
            url+=`&node=${selDeviceNodeIds.join(",")}`
        }
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        if(todoCon&&todoCon?.showEarlyWarn){
           url+=`&earlyWarn=true` 
        }
        
        http.get(url,{}).then((data) => {
            setData([]);
            setDataSave([]);
            setIsLoading(false);
            if (data.code === 0&&data.data!==null) {
                if(data.data.findIndex(x=>x.status===0&&showalarmtype.includes(x.type))!==-1){
                    !state.alarmSound&&audioEle.play();
                }
                // for (let i = 0; i < data.data.length; i++) {
                //     data.data[i]['key'] = i;
                // }
                let tempData = data.data
                tempData.sort((a,b)=>{
                    if(a.alarm_date===b.alarm_date){
                        return b.id -a.id;
                    }else{
                       return new Date(b.alarm_date).getTime()-new Date(a.alarm_date).getTime()
                    }
                });
                if(showAlarmDeal){
                    let newList=[]
                    tempData.map(m=>{
                        let obj;
                        if(m.msg!==''){
                            obj= JSON.parse(m.msg);
                        }
                        m.why = obj?.why?obj.why:'';
                        m.who = obj?.who?obj.who:'';
                        m.deal = obj?.deal?obj.deal:'';
                        newList.push(m)
                    })
                    tempData = newList
                }
                setData(tempData);
                setDataSave(tempData);
            }
        })
    }
    useEffect( async() => {
        const controller = new AbortController();
        setIsDash(props?.isDash)
        let  typeOptions = [];
        let todo = state.mainTodo;
        alarmtype[214]='探头温度预警恢复';
        alarmtype[215]='探头湿度预警恢复';
        if(Version!=='PC'){
            alarmtype[10]=`探头温度超标报警`;
            alarmtype[25]=`探头温度超标报警`;
            alarmtype[12]=`探头湿度超标报警`;
            alarmtype[26]=`探头湿度超标报警`;
            typeOptions.push({ value: 10 ,label: '探头温度超标报警',text: '探头温度超标报警' })
            typeOptions.push({ value: 11 ,label: '探头温度恢复报警',text: '探头温度恢复报警' })
            typeOptions.push({ value: 12 ,label: '探头湿度超标报警',text: '探头湿度超标报警' })
            typeOptions.push({ value: 13 ,label: '探头湿度恢复报警',text: '探头湿度恢复报警' })
        }else{
            console.log('!!!增加类型查询');
            
            typeOptions.push({ value: 10 ,label: '探头温度超上限报警',text: '探头温度超上限报警' })
            typeOptions.push({ value: 25 ,label: '探头温度超下限报警', text: '探头温度超下限报警' })
            typeOptions.push({ value: 11 ,label: '探头温度恢复报警',text: '探头温度恢复报警' })
            typeOptions.push({ value: 12 ,label: '探头湿度超上限报警',text: '探头湿度超上限报警' })
            typeOptions.push({ value: 26 ,label: '探头湿度超下限报警',text: '探头湿度超下限报警' })
            typeOptions.push({ value: 13 ,label: '探头湿度恢复报警',text: '探头湿度恢复报警' })
        }
        
        for(let i = 0; i < 10; i++) {
            typeOptions.push({ value: i ,label: alarmtype[i],text: alarmtype[i] })
        }
        
        let todoCon = (todo&&todo!=='')?JSON.parse(todo):null
        if(todoCon&&todoCon?.showEarlyWarn){
            typeOptions.push({ value: 14 ,label: '探头温度预警',text: '探头温度预警' })
            typeOptions.push({ value: 15 ,label: '探头湿度预警',text: '探头湿度预警' })
            typeOptions.push({ value: 214 ,label: '探头温度预警恢复',text: '探头温度预警恢复' })
            typeOptions.push({ value: 215 ,label: '探头湿度预警恢复',text: '探头湿度预警恢复' })
        }
        let audioEle = document.getElementById('audio');
        http.get("/v1/district", {}, {
            signal: controller.signal // 将信号传给 axios
          }).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'district', district: data.data });
                setSelUserDis(data.data);
            }
        })
        http.get("/v1/users", {} ,{
            signal: controller.signal // 将信号传给 axios
          }).then(data => {
            if (data.code === 0) {
                let temp = data.data.sort((a,b)=>a.name.localeCompare(b.name,'zh'))
                dispatch({ type: 'systemuser', systemuser: temp })
                if(data.data.length>0){
                    var userLogin =state.main;
                    var list = [];
                    temp.filter(x=>x.parent===userLogin.id).map(m=>list.push(m.id+""));
                    setDefExpend(list);         
                } 
            }
        })
        http.get("/v1/userdistricts", {},{
            signal: controller.signal // 将信号传给 axios
          }).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'user_district', user_district: data.data })
            }
        })
        await http.get("/v1/device", {},{
            signal: controller.signal // 将信号传给 axios
          }).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'device', device: data.data })
                let arrDev = new Array();
                let arrDevice = new Array();
                let electric = new Array();
                let havePa = false;
                data.data.map(m => {
                    if(m.type===216){
                        electric.push({ node:m.node, sn:m.sn });
                    }
                    if(!havePa && [205,210,211].includes(m.type)){
                        havePa = true;
                    }
                    arrDev.push({ label: m.name+'-'+m.sn, value: m.id,sn:m.sn ,node:m.node,district :m.district,key:m.id});
                    arrDevice.findIndex(x => x.value === m.sn) === -1 && arrDevice.push({ label: m.m_name+'-'+m.sn, value: m.sn ,district :m.district,key:m.id});
                })
                setNodeFliters(arrDev);
                setDisNodes(arrDev);
                setAlarmDevOption(arrDevice);
                setDevFliters(arrDevice);
                let alarmTypeIndex = 18;
                if(havePa){
                    alarmTypeIndex = 16
                }
                for(let i = alarmTypeIndex; i <25; i++) {
                    if(alarmtype[i]!==''){
                        typeOptions.push({ value: i ,label: alarmtype[i],text: alarmtype[i] })
                    }
                }
                if (data.data.every(x=>x.type===216)){
                    typeOptions = [];
                }
                if(electric.length>0){
                    typeOptions.push({ value: 27 ,label: '风机运行状态开启',text: '风机运行状态开启' })
                    typeOptions.push({ value: 28 ,label: '风机运行状态关闭',text: '风机运行状态关闭' })
                    typeOptions.push({ value: 29 ,label: '绕组超温跳闸报警',text: '绕组超温跳闸报警' })
                    typeOptions.push({ value: 30 ,label: '绕组超温跳闸恢复',text: '绕组超温跳闸恢复' })
                    typeOptions.push({ value: 10010 ,label: '绕组超温报警开启',text: '绕组超温报警开启' })
                    typeOptions.push({ value: 10011 ,label: '绕组超温报警恢复',text: '绕组超温报警恢复' })
                    typeOptions.push({ value: 10022 ,label: '温控装置故障报警',text: '温控装置故障报警' })
                    typeOptions.push({ value: 10023 ,label: '温控装置故障恢复',text: '温控装置故障恢复' })
                    typeOptions.push({ value: 10004 ,label: '温控装置开路报警',text: '温控装置开路报警' })
                    typeOptions.push({ value: 10005 ,label: '温控装置开路恢复',text: '温控装置开路恢复' })
                }
                ///漏水监测设备
                if (data.data.every(x=>x.type===217)){
                    typeOptions = [];
                    typeOptions.push({ value: 0 ,label: alarmtype[0],text: alarmtype[0] })
                    typeOptions.push({ value: 1 ,label: alarmtype[1],text: alarmtype[1] })
                    typeOptions.push({ value: 6 ,label: '漏水报警',text: '漏水报警' })
                    typeOptions.push({ value: 7 ,label: '漏水恢复',text: '漏水恢复' })
                    // typeOptions[12].label ='漏水报警'
                    // typeOptions[12].text ='漏水报警'
                    // typeOptions[13].label ='漏水恢复'
                    // typeOptions[13].text ='漏水恢复'
                }else if (data.data.some(x=>x.type===217)){
                    typeOptions[12].label =alarmtype[6]+'或漏水报警'
                    typeOptions[12].text =alarmtype[6]+'或漏水报警'
                    typeOptions[13].label =alarmtype[7] +'或漏水恢复'
                    typeOptions[13].text =alarmtype[7] +'或漏水恢复'
                    // typeOptions[6] ={ value: 6 ,label:alarmtype[6]+'或漏水报警' ,text: alarmtype[6]+'或漏水报警' }
                    
                    // typeOptions[7] ={ value: 7 ,label:alarmtype[7] +'或漏水恢复' ,text: alarmtype[7] +'或漏水恢复' }
                }
                console.log('typeOptions',typeOptions);
                
                setAlarmTypeOption([...typeOptions])
                setElectricList(electric)
            }
        })
        if((Mode==='soc'&&state.main.type>101)||Mode==='local'){
            setIsLoading(true);
            http.get("/v1/alarmday?day=" + formatDateTimes(new Date()), {},{
                signal: controller.signal, // 将信号传给 axios
                // onDownloadProgress: (progressEvent) => {
                //     // 确保 total 存在（后端必须返回 Content-Length 响应头）
                //     if (progressEvent.total) {
                //       const currentPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                //     //   setPercent(currentPercent);
                //       console.log(`当前下载进度: ${currentPercent}%`);
                //     }
                //   }
              }).then(data => {
                setIsLoading(false);
                if (data.code === 0&&data.data) {
                    if(data.data.findIndex(x=>x.status===0&&showalarmtype.includes(x.type))!==-1){
                        !state.alarmSound&&audioEle.play();
                      }
                    // for (var i = 0; i < data.data.length; i++) {
                    //     data.data[i]['key'] = data.data[i].id;
                    // }
                    let tempData = data.data
                    if(tempData.length>0){
                        tempData.sort((a,b)=>{
                            if(a?.alarm_date===b?.alarm_date){
                                return b?.id -a?.id;
                            }else{
                               return new Date(b?.alarm_date).getTime()-new Date(a?.alarm_date).getTime()
                            }
                        });
                        if(props&&props?.isDash){
                            props?.onValueChange(tempData.length)
                        }
                    }
                    setData(tempData);
                    setDataSave(tempData);
                }
            })
        }
        return   () => {
            controller.abort();
          };
    }, []);
    useEffect(() => {
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        let audioInterval = 1000*60*5;
        if(todoCon&&todoCon.sginEnable){
            setSginEnable(true);
            setMySgin(todoCon.mySgin?todoCon.mySgin:'')
        }
        if(todoCon&&todoCon?.audioPlayInterval){
            audioInterval = todoCon.audioPlayInterval*1000
            if(audioInterval<20000){
                audioInterval = 20000
            }
        }
        clearInterval(interval);
        interval = setInterval(() => {
          if (!closeInterval) {
            getAlarmDataS()
          } else {
            clearInterval(interval)
          }
        },audioInterval)
        return () => clearInterval(interval)
    }, [closeInterval,startTime,endTime,selUser,selDis,state.mainTodo])
    const columnsLeft = [{
        title: '报警时间',
        dataIndex: 'alarm_date',
        align: 'center',
        width: 100,
        render: (text, record) => (
            <div>{text.slice(2,-3)}</div>
        )
    }]
    const columnsRight = [
        {
            title: '所属区域',
            dataIndex: 'districtname',
            align: 'center',
            width:200,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 ,width: '100%', boxSizing: 'border-box' }}>
                    <Input
                        placeholder='区域信息'
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => clearFilters()}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => record.districtname ? record.districtname.indexOf(value.trim()) !== -1 : ''
        },
        {
            title: '主机',
            dataIndex: 'device',
            align: 'center',
            width:200,
            render: (text, record) => (
                <div>
                    <div>{record.m_name}</div>
                    <div style={{ fontSize: 10, color: '#aaa' }}>编号:{record.device}</div>
                </div>
            ),
            sorter: {
                compare: (a, b) => a.node - b.node,
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>{
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder='主机信息'
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => {
                                setSelDev(selectedKeys[0])
                                confirm()
                            }}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Space>
                            <Button size="small" style={{ width: 90 }} onClick={() => {
                                setSelDev('');
                                clearFilters()
                            }}>
                                重置
                            </Button>
                            <Button
                                type="primary"
                                onClick={() =>{ 
                                    setSelDev(selectedKeys[0]?selectedKeys[0]:'')
                                    confirm()
                                }}
                                icon={<SearchOutlined />}
                                size="small"
                                style={{ width: 90 }}
                            >
                                查找
                            </Button>
    
                        </Space>
                    </div>
                )
            }
            ,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => {
                return record.device ? record.device.toString().indexOf(value.trim()) !== -1 || record.m_name.toString().indexOf(value.trim()) !== -1 : ''
            }
        },
        {
            title: '测点',
            dataIndex: 'node',
            align: 'center',
            width:200,
            render: (text, record) => (
                record.node===0? <div>--</div>:
                <div>
                    <div>{record.name}</div>
                    <div style={{ fontSize: 10, color: '#aaa' }}>编号:{record.node}</div>
                </div>
            ),
            sorter: {
                compare: (a, b) => a.node - b.node,
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder='测点信息'
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => {
                            setSelNode(selectedKeys[0])
                            confirm()
                        }}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {clearFilters();setSelNode('')}}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                setSelNode(selectedKeys[0])
                                confirm()
                            }}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => record.node ? record.node.toString().indexOf(value.trim()) !== -1 || record.name.toString().indexOf(value.trim()) !== -1 : ''
        },
        {
            title: '报警类型',
            dataIndex: 'type',
            // key: 'type',
            align: 'left',
            width: 150,
            render: (text, record) => {
                if(electricList.length>0 && electricList.findIndex(item=>item.node===record.node&&item.sn===record.device)>=0){
                    return(
                        <div>{alarmTypeOption.filter(x=>x.value===10000+record.type||x.value===record.type)[0]?.label}</div>
                    )
                }else{
                    if(Version!=='PC'){
                        return(
                            <div>{alarmtype[record.type]}</div>
                        )
                    }else{
                        if(isNewType){
                            if(record.type===10){
                                if(record.temp<record.temp_l){
                                    return(
                                        <div>探头温度超下限报警</div>
                                    )
                                }
                                if(record.temp>record.temp_h){
                                    return(
                                        <div>探头温度超上限报警</div>
                                    )
                                }
                            }else if(record.type===12){
                                if(record.humi<record.humi_l){
                                    return(
                                        <div>探头湿度超下限报警</div>
                                    )
                                }
                                if(record.humi>record.humi_h){
                                    return(
                                        <div>探头湿度超上限报警</div>
                                    )
                                }
                            }else if([6,7].includes(record.type)){
                                let devs= state.device.filter(x=>x.sn===record.device&&x.node===record.node)
                                if(devs&&devs.length>0&&devs[0].type===217){
                                    let show ='漏水'
                                    if(record.type===7){
                                        show='漏水恢复'
                                    }
                                    return(<div>{show}</div>)
                                }else{
                                    return(
                                        <div>{alarmtype[record.type]}</div>
                                    )
                                }
                            }else{
                                return(
                                    <div>{alarmtype[record.type]}</div>
                                )
                            }
                        }else if([6,7].includes(record.type)){
                            let devs= state.device.filter(x=>x.sn===record.device&&x.node===record.node)
                            if(devs&&devs.length>0&&devs[0].type===217){
                                let show ='漏水'
                                if(record.type===7){
                                    show='漏水恢复'
                                }
                                return(<div>{show}</div>)
                            }else{
                                return(
                                    <div>{alarmtype[record.type]}</div>
                                )
                            }
                        }
                        else{
                            return(
                                <div>{alarmtype[record.type]}</div>
                            )
                        }
                    }
                    
                    
                }
               
            },
            sorter: {
                compare: (a, b) => a.type - b.type,
            },
            filters:alarmTypeOption,
            onFilter: (value, record) => {
                return  record?record.type === value :''
            },
            filterDropdownProps: {
                overlayClassName: 'custom-filter-dropdown', // 👈 添加这个类名
            }
        },
        {
            title: '记录值',
            // dataIndex: 'temp',
            // key: 'temp',
            align: 'center',
            width: 150,
            render: (text, record) =>{ 
                if([10,11,14,25,214].includes(record.type)){
                    return(
                        <div>
                            <div>{record.temp}℃</div>
                            <div style={{ fontSize: 10, color: '#aaa' }}>上限:{record.temp_h}℃-下限:{record.temp_l}℃</div>
                        </div>
                    )
                }
                if([12,13,15,26,215].includes(record.type)) return (
                    <div>
                        <div>{record.humi}%RH</div>
                        <div style={{ fontSize: 10, color: '#aaa' }}>上限:{record.humi_h}%RH-下限:{record.humi_l}%RH</div>
                    </div>
                )
                if(record.type===16||record.type===17) return(
                    <div>
                        <div>{record.temp}Pa</div>
                        <div style={{ fontSize: 10, color: '#aaa' }}>上限:{record.temp_h}Pa-下限:{record.temp_l}Pa</div>
                    </div>
                )
                if(record.type===18) return(
                    <div>
                        <div>{record.temp}%</div>
                    </div>
                )
            }
        },
        {
            title: '状态',
            dataIndex: 'status',
            align: 'center',
            width: 80,
            sorter: {
                compare: (a, b) => a.status - b.status,
            },
            render: (text, record) => (
                (showalarmtype.includes(record.type))?record.status === 0 ? <Tag color={'red'}>未处理</Tag> :
                <Dropdown overlay={(
                    <Menu>
                      <Menu.Item>
                        <div>报警原因：{JSON.parse(record.msg).why || "未知"}</div>
                      </Menu.Item>
                      <Menu.Item >
                        <div>处理人员：{JSON.parse(record.msg).who || "未知"}</div>
                      </Menu.Item>
                      <Menu.Item >
                        <div>处理措施：{JSON.parse(record.msg).deal || "未知"}</div>
                      </Menu.Item>
                    </Menu>
                  )}>
                    <a className="ant-dropdown-link" onClick={e => {
                        if(state.main.role.indexOf('312')===-1) return
                        e.preventDefault() ;
                        setShowDealMsg(JSON.parse(record.msg));
                        setShowData(record);
                        setShowDealMsgBox(true)
                        }}
                        onMouseOver={()=>{setShowDealMsg(JSON.parse(record.msg));
                        }}
                        >已处理</a>
                </Dropdown>:''
            ),
            filters: [
                {
                    text: '未处理',
                    value: 0
                },
                {
                    text: '已处理',
                    value: 1
                },
            ],
            onFilter: (value, record) => record.status === value && showalarmtype.includes(record.type)
        }
    ]
    const columnsSoc= [
        {
            title: '所属用户',
            dataIndex: 'user',
            align: 'center',
            width:200,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder='用户信息'
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => clearFilters()}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => record.user ? record.user.indexOf(value.trim()) !== -1 : ''
        },
        
    ]
    const columnsAdd=[
        {
            title: '报警原因',
            dataIndex: 'why',
            align: 'center',
            width:100,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>{
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder='报警原因'
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => {
                                confirm()
                            }}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Space>
                            <Button size="small" style={{ width: 90 }} onClick={() => {
                                clearFilters()
                            }}>
                                重置
                            </Button>
                            <Button
                                type="primary"
                                onClick={() =>{ 
                                    confirm()
                                }}
                                icon={<SearchOutlined />}
                                size="small"
                                style={{ width: 90 }}
                            >
                                查找
                            </Button>
    
                        </Space>
                    </div>
                )
            }
            ,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => {
                return record?.why ? record?.why.toString().includes(value.trim()) : ''
            }
        },
        {
            title: '处理人员',
            dataIndex: 'who',
            align: 'center',
            width:100,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>{
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder='处理人员'
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => {
                                confirm()
                            }}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Space>
                            <Button size="small" style={{ width: 90 }} onClick={() => {
                                clearFilters()
                            }}>
                                重置
                            </Button>
                            <Button
                                type="primary"
                                onClick={() =>{ 
                                    confirm()
                                }}
                                icon={<SearchOutlined />}
                                size="small"
                                style={{ width: 90 }}
                            >
                                查找
                            </Button>
    
                        </Space>
                    </div>
                )
            }
            ,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => {
                return record?.who ? record?.who.toString().includes(value.trim()) : ''
            }
        },
        {
            title: '处理措施',
            dataIndex: 'deal',
            align: 'center',
            width:100,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>{
                return (
                    <div style={{ padding: 8 }}>
                        <Input
                            placeholder='处理措施'
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => {
                                confirm()
                            }}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                        <Space>
                            <Button size="small" style={{ width: 90 }} onClick={() => {
                                clearFilters()
                            }}>
                                重置
                            </Button>
                            <Button
                                type="primary"
                                onClick={() =>{ 
                                    confirm()
                                }}
                                icon={<SearchOutlined />}
                                size="small"
                                style={{ width: 90 }}
                            >
                                查找
                            </Button>
    
                        </Space>
                    </div>
                )
            }
            ,
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            onFilter: (value, record) => {
                return record?.deal ? record?.deal.toString().includes(value.trim()) : ''
            }
        }
    ]
    const columns = useMemo(()=>{
        if(Mode!=='soc'){
            let result =[...columnsLeft,...columnsRight]
            if(showAlarmDeal){
                result =[...result,...columnsAdd]
            }
            return result
        }else{
            let result =[...columnsLeft,...columnsSoc,...columnsRight]
            if(showAlarmDeal){
                result =[...result,...columnsAdd]
            }
            return result
        }
    },[showAlarmDeal,alarmTypeOption]) 
   
    const onSelectChange = (selectedRowKeys,selectedRows) => {
        setSelectedRowKeys(selectedRowKeys)
    };
    /**
     * 判断哪些记录可以勾选
     */
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: !showalarmtype.includes(record.type), // Column configuration not to be checked
        }),
    };
    return (

        <div style={{height:'100%',backgroundColor:'#fff',width:'100%',padding:10,position:'relative'}}>
            {
                showSgin&&<Sign getMySgin={(val)=>{
                    setShowSgin(false);
                    // setShowDeal(true)
                    setTimeout(() => {
                        if(val===mySgin){
                            setSgin(val);
                            form.submit()
                        }else{
                            setSgin('');
                            Modal.error({
                                title: '错误',
                                centered: true,
                                content: '电子签名不匹配',
                            });
                        }
                    }, 500);
                    
                }} val ={showSgin}></Sign>
            }
            {
                isDash?
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div className='HeardTitle'>当日报警数据看板</div>
                    <Button type={"primary"} style={{ marginLeft: 5,borderRadius:10 }} onClick={() => {
                        const sle = data.filter(x => { return selectedRowKeys.indexOf(x.id) > -1 })
                        if(sle.length===0) return message.warn("未选择报警记录",3);
                        var nsle = new Array()
                        sle.map(item => {
                            nsle.push({ id: item.id, date: item.alarm_date })
                        })
                        setDealList(nsle)
                        setShowDeal(true)
                        }}
                    >处理报警</Button>
                </div>
                :
                <div style={{border:'1px solid #ccc',padding:'10px 20px',width:'100%'}}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5,justifyContent:'space-between' }}>

                        <audio id="audio"  src={audioSrc} />
                        <div>
                        {
                            Mode==='soc'&&<TreeSelect
                            showSearch
                            style={{ width: state.resolution.width>1644?360:280 }}
                            dropdownStyle={{ maxHeight: 500, overflow: 'auto' }}
                            placeholder="选择用户"
                            allowClear
                            // multiple
                            optionFilterProp="label"
                            treeDefaultExpandedKeys={defExpend}
                            onChange={value=> {
                                setSelDis(undefined)
                                setSelAlarmDev(undefined)
                                setSelDeviceNodes([])
                                setSelDeviceNodeIds([])
                                if(value===undefined||value===0){//清空用户选择
                                    setData(dataSave);//默认全部
                                    setSelUserDis(state.district);//清空已选择用户的区域
                                    setSelUser(0);//清空选择用户给区域选择提供判定条件
                                    setAlarmDevOption(devFliters)
                                    setDisNodes(nodeFliters)
                                }else{
                                    setSelUser(value);
                                    let userDis = state.district.filter(x=>x.user===value);
                                    findUserDis(value,state.systemuser.list,state.district,userDis);
                                    let temp=[];
                                    setSelUserDis(userDis);
                                    let devOptions = []
                                    let nodeOptions =[]
                                    userDis.map(item=>{
                                        temp= temp.concat(dataSave.filter(x=>x.district === item.id));
                                        devOptions = devOptions.concat(devFliters.filter(x=>x.district ===item.id))
                                        nodeOptions = nodeOptions.concat(nodeFliters.filter(x=>x.district ===item.id))
                                    })
                                    setAlarmDevOption(devOptions);//主机选项内容
                                    setDisNodes(nodeOptions);//测点选项内容
                                    setData(temp.sort((a,b)=>new Date(b.alarm_date).getTime()-new Date(a.alarm_date).getTime()));//筛选显示的报警信息
                                }  
                                
                            }}
                            // treeData={[{title:'全部',value:'全部'}].concat(state.systemuser.tree)}
                            treeData={state.systemuser.treeM}
                            filterTreeNode = {(input,option)=>{
                                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 
                                || option.account.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                || option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            />
                        }
                        <Select allowClear showSearch optionFilterProp="children" placeholder="选择区域"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={selDis}
                            // mode="multiple"
                            style={{ width: state.resolution.width>1644?360:280, marginLeft: 10 }}
                            
                            onChange={val=>{
                                let temp=[];
                                setSelDis(undefined);
                                setSelAlarmDev(undefined)
                                setSelDeviceNodes([])
                                setSelDeviceNodeIds([])
                                if((val===0||val===undefined)&&selUser===0){

                                    temp=dataSave;
                                    setDisNodes(nodeFliters)
                                    setAlarmDevOption(devFliters)//主机选项内容
                                }else if((val===0||val===undefined)&&selUser>0){
                                    let devOptions = []
                                    let nodeOptions =[]
                                    selUserDis.map(item=>{
                                        temp= temp.concat(dataSave.filter(x=>x.district === item.id));
                                        devOptions = devOptions.concat(devFliters.filter(x=>x.district ===item.id))
                                        nodeOptions = nodeOptions.concat(nodeFliters.filter(x=>x.district ===item.id))
                                    })
                                    setAlarmDevOption(devOptions);//主机选项内容
                                    setDisNodes(nodeOptions);//测点选项内容
                                }else if(val>0){
                                    setSelDis(val);
                                    if(selUser===0){
                                        let userId=selUserDis.filter(x=>x.id===val)[0]?.user
                                        setSelUser(userId);
                                    }
                                    temp= dataSave.filter(x=>x.district === val);
                                    setDisNodes(nodeFliters.filter(x=>x.district===val))//测点选项内容
                                    setAlarmDevOption(devFliters.filter(x=>x.district === val))//主机选项内容
                                }
                                setData(temp);
                            }}
                        >
                            {
                                (()=>{
                                    let disData=selUserDis;
                                    return disData.map(item => (
                                        <Select.Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    ))
                                })()
                            }
                        </Select>
                        {
                            state.resolution.width>1644&&

                            <Select allowClear showSearch optionFilterProp="children"  style={{ width: 200, marginLeft: 10 }} placeholder="选择报警类型"
                            filterOption={(input, option) =>
                                // console.log('option',option,'input',input)
                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={selAlarmType}
                            // mode="multiple"
                            
                            onChange={val=>{
                                setSelAlarmType(undefined);
                                if(val!==undefined){
                                    setSelAlarmType(val);
                                }
                            }}
                            options={alarmTypeOption}
                        >
                        </Select> 
                        }  
                        </div>
                        <div >
                                <span>自动</span><Switch style={{ marginLeft: 10 }} checkedChildren="开启" unCheckedChildren="关闭" defaultChecked onChange={autoRefresh} />
                                <Tooltip title='刷新'><Button style={{ marginLeft: 10,marginRight:10 }} shape="circle" icon={<SyncOutlined style={{ fontSize: '20px' }} onClick={getAlarmDataS} />} /></Tooltip> 
                            
                                <Checkbox value={showAlarmDeal} onChange={e=>{
                                    setShowAlarmDeal(e.target.checked)
                                    let newList=[]
                                    data.map(m=>{
                                        let obj;
                                        if(m.msg!==''){
                                            obj= JSON.parse(m.msg);
                                        }
                                        m.why = obj?.why?obj.why:'';
                                        m.who = obj?.who?obj.who:'';
                                        m.deal = obj?.deal?obj.deal:'';
                                        newList.push(m)
                                    })
                                    setData(newList)
                                }}>处理展示</Checkbox>
                                {
                                    state.resolution.width>1644&&<Button type={"primary"} style={{borderRadius:10}} onClick={getAlarmDataS}>查询</Button>
                                }
                                
                        </div>
                    </div>
                    {/* 页面宽度低于1645时 */}
                    {
                        state.resolution.width<1645&&
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5,justifyContent:'space-between' }}>
                            <div>
                                <Select allowClear showSearch optionFilterProp="children"  style={{ width: 200 }} placeholder="选择报警类型"
                                    filterOption={(input, option) =>
                                        // console.log('option',option,'input',input)
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={selAlarmType}
                                    // mode="multiple"
                                    
                                    onChange={val=>{
                                        setSelAlarmType(undefined);
                                        if(val!==undefined){
                                            setSelAlarmType(val);
                                        }
                                    }}
                                    options={alarmTypeOption}
                                >
                                </Select> 
                                <RangePicker style={{ marginLeft: 10 ,borderRadius:10}}
                                    allowEmpty={[false,true]}
                                    ranges={{
                                        今天: [moment().startOf('day'), moment()],
                                        '本周': [moment().startOf('week'), moment().endOf('week')],
                                        '本月': [moment().startOf('month'), moment().endOf('month')],
                                    }}
                                    showTime
                                    format="YYYY-MM-DD HH:mm"
                                    onChange={(dates, dateStrings) => {
                                        if(dates===null){
                                            setStartTime('');
                                            setEndTime('');
                                        }else{
                                            setStartTime(dateStrings[0]+':00');
                                            dates[1]!==null&&setEndTime(dateStrings[1]+':00');
                                        }   
                                    }}
                                />
                            </div>
                            <div>
                                <Button type={"primary"} style={{borderRadius:10}} onClick={getAlarmDataS}>查询</Button>
                                <Button type={"primary"} style={{ marginLeft: 5,borderRadius:10 }} onClick={() => {
                                    const sle = data.filter(x => { return selectedRowKeys.indexOf(x.id) > -1 })
                                    console.log('deal',data,'key',selectedRowKeys,'che',sle);
                                    if(sle.length===0) return message.warn("未选择报警记录",3);
                                    var nsle = new Array()
                                    sle.map(item => {
                                        nsle.push({ id: item.id, date: item.alarm_date })
                                    })
                                    setDealList(nsle)
                                    setShowDeal(true)
                                    }}
                                >处理报警</Button>
                            </div>
                        </div>
                    }
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <div>
                        {/* <span margin-left='14px' style={{ fontSize: 14 }}>主机</span> */}
                        <Select showSearch optionFilterProp="label" allowClear  
                            filterOption={(input, option) =>
                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={value => {   
                                setSelDeviceNodes([])
                                setSelDeviceNodeIds([])
                                setSelAlarmDev(value);
                                if(value){
                                    setDisNodes(nodeFliters.filter(x=>x.sn===value))
                                }else{
                                    let nodeOptions =[]
                                    if(selDis>0){
                                        nodeOptions = nodeFliters.filter(x=>x.district ===selDis)
                                    }else{
                                        selUserDis.map(item=>{
                                            nodeOptions = nodeOptions.concat(nodeFliters.filter(x=>x.district ===item.id))
                                        })
                                    }
                                    setDisNodes(nodeOptions);//测点选项内容
                                }
                            }}
                            options={alarmDevOption}
                            value={selAlarmDev}
                            style={{ width: 260 }}
                            placeholder="选择主机" />
                        {/* <span style={{ fontSize: 14, marginLeft: 20 }}>测点</span> */}
                        <Select allowClear showSearch 
                            mode="multiple"
                            style={{ width: 300, marginLeft: 10 }}
                            value={selDeviceNodes}
                            placeholder="选择测点"
                            optionFilterProp="children"
                            maxTagCount = 'responsive'
                            // disabled = {selAlarmDev!==undefined &&selAlarmDev!==""}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={d => {
                                setSelDeviceNodes(d);
                                let sd  = []
                                if(d.length>0){
                                    sd = state.device.filter(x => { return d.includes(x.id)});   
                                }
                                if (sd.length > 0) {
                                    let devNodes = [];
                                    sd.map(it=>{
                                        devNodes.push(it.node)
                                    })
                                    setSelDeviceNodeIds(devNodes);
                                    setDisNodes(nodeFliters.filter(x=>x.sn===sd[0].sn))
                                    setSelAlarmDev(sd[0].sn)
                                } else {
                                    setSelAlarmDev(undefined)
                                    let nodeOptions =[]
                                    if(selDis>0){
                                        nodeOptions = nodeFliters.filter(x=>x.district ===selDis)
                                    }else{
                                        selUserDis.map(item=>{
                                            nodeOptions = nodeOptions.concat(nodeFliters.filter(x=>x.district ===item.id))
                                        })
                                    }
                                    setDisNodes(nodeOptions)
                                }
                                
                            }}
                        >
                            {
                                disNodes.map(item => (
                                    <Select.Option key={item.key} value={item.value}>
                                        {item.label}
                                    </Select.Option>
                                ))
                            }
                        </Select>
                    
                        {
                             state.resolution.width>1644&&
                            <RangePicker style={{ marginLeft: 20 ,borderRadius:10}}
                            allowEmpty={[false,true]}
                            ranges={{
                                今天: [moment().startOf('day'), moment()],
                                '本周': [moment().startOf('week'), moment().endOf('week')],
                                '本月': [moment().startOf('month'), moment().endOf('month')],
                            }}
                            showTime
                            format="YYYY-MM-DD HH:mm"
                            onChange={(dates, dateStrings) => {
                                if(dates===null){
                                    setStartTime('');
                                    setEndTime('');
                                }else{
                                    setStartTime(dateStrings[0]+':00');
                                    dates[1]!==null&&setEndTime(dateStrings[1]+':00');
                                }   
                            }}
                        />
                        }
                        </div>

                        <div style={{display:'flex'}}>
                            
                        {/* <Button onClick={() => {
                        exportCsv({
                            title: ["id","m_name","device","name","node","districtname","district","type","alarm_date","temp","temp_h","temp_l","humi","humi_h","humi_l",
                                "msg","status","humienable","user"],
                            data: [...data]
                        })
                            }}>导出CSV</Button> */}
                            {/* 下载EXCEL */}
                            {
                                state.super>1&&
                            <Button style={{borderRadius:10}} 
                            onClick={() => {
                                var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                                let url = "/v1/alarmexcel?" ;
                                startTime === ''? url += "starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                                endTime===''? url+="starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
                                url+="starttime=" + startTime + "&endtime=" + endTime;
                                if(selUser!==0){
                                    url+=`&user=${selUser}`
                                }
                                if(selDis!==''){
                                    url+=`&district=${selDis}`
                                }
                                if(selAlarmDev!==''){
                                    url+=`&device=${selAlarmDev}`
                                }
                                if(selDeviceNodeIds.length>0){
                                    url+=`&node=${selDeviceNodeIds.join(",")}`
                                }

                                fetch(url, { //downloadFiles 接口请求地址
                                    method: 'get',
                                    credentials: 'include',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                                    })
                                })
                                .then(response => {
                                    response.blob().then(blob => {
                                        let blobUrl = window.URL.createObjectURL(blob);
                                        let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                        let filename = new Date().toLocaleDateString()+ '.xlsx';//设置文件名称
                                        aElement.href = blobUrl;//设置a标签路径
                                        aElement.download = filename;
                                        aElement.click();
                                        window.URL.revokeObjectURL(blobUrl);
                                    });
                                }).catch((error) => {
                                    console.log('文件下载失败', error);
                                })
                                }}>下载EXCEL</Button>
                            }
                            {/* 下载PDF */}
                            {
                                // Mode==='soc'&&
                            <Button style={{borderRadius:10}} 
                            onClick={() => {
                                var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                                let url = "/v1/alarmpdf?" ;
                                startTime === ''? url += "starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                                endTime===''? url+="starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
                                url+="starttime=" + startTime + "&endtime=" + endTime;
                                // if(selUser!==0){
                                //     if(selDis!==''){
                                //         url+= `user=${selUser}&district=${selDis}&`
                                //     }else{
                                //         url+=`user=${selUser}&`
                                //     }
                                // }else{
                                //     if(selDis!==''){
                                //         url+= `district=${selDis}&`
                                //     }
                                // }
                                if(selUser!==0){
                                    url+=`&user=${selUser}`
                                }
                                if(selDis&&selDis!==''){
                                    url+=`&district=${selDis}`
                                }
                                if(selAlarmDev&&selAlarmDev!==''){
                                    url+=`&device=${selAlarmDev}`
                                }
                                if(selDeviceNodeIds.length>0){
                                    url+=`&node=${selDeviceNodeIds.join(",")}`
                                }
                            
                                if(Mode==='soc'){
                                    fetch(url, { //downloadFiles 接口请求地址
                                        method: 'get',
                                        credentials: 'include',
                                        headers: new Headers({
                                            'Content-Type': 'application/json',
                                            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                                        })
                                    })
                                    .then(response => {
                                        response.blob().then(blob => {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                            let filename = new Date().toLocaleDateString()+ '.pdf';//设置文件名称
                                            aElement.href = blobUrl;//设置a标签路径
                                            aElement.download = filename;
                                            aElement.click();
                                            window.URL.revokeObjectURL(blobUrl);
                                        });
                                    }).catch((error) => {
                                        console.log('文件下载失败', error);
                                    })
                                }
                                else{
                                    if(window.CefSharp!==undefined){
                                        window.CefSharp.BindObjectAsync("bound");
                                        let path = window.bound.exportPDF(new Date().toLocaleDateString('zh-CN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit'
                                        }).replace(/\//g, '-') + '.pdf');
                                        url+="&path=" + path;
                                        http.get(url, {}).then(data=>{
                                            if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                                        })
                                    }
                                }
                                }}>下载PDF</Button>
                            }
                            {
                                Version==='PC'&&
                                <Button type={"primary"} style={{ marginLeft: 5,borderRadius:10 }} onClick={() => {
                                    if(selAlarmType===''){
                                        return message.warn("未选择报警类型",3);
                                    }
                                    getAlarmDataS()
                                    setShowDeal(true)
                                    setIsDealAlarmMore(true)
                                    }}
                                >批量处理报警</Button>
                            }
                            {
                                state.resolution.width>1644&&
                                <Button type={"primary"} style={{ marginLeft: 5,borderRadius:10 }} onClick={() => {
                                    const sle = data.filter(x => { return selectedRowKeys.indexOf(x.id) > -1 })
                                    console.log('deal',data,'key',selectedRowKeys,'che',sle);
                                    if(sle.length===0) return message.warn("未选择报警记录",3);
                                    var nsle = new Array()
                                    sle.map(item => {
                                        nsle.push({ id: item.id, date: item.alarm_date })
                                    })
                                    setDealList(nsle)
                                    setShowDeal(true)
                                    }}
                                >处理报警</Button>
                            }
                            
                            <a id="downloadDiv" style={{ display: 'none' }}></a>
                        </div>
                    </div>
                </div>
            }
            
            <div style={{border:'1px solid #ccc',marginTop:10,maxHeight:'78vh',position:'absolute',width:'100%' }}>
                {/* 报警展示 */}
                <Table rowKey={record =>record.id} rowSelection={rowSelection} size={"small"} bordered columns={columns} pagination={{ showSizeChanger:true,pageSizeOptions:[10,20,50,100,500,1000,10000,100000],hideOnSinglePage:true }} dataSource={data}  loading={isLoading}
                    scroll={{x:1400,y:isDash?'50vh':state.resolution.height>1000?state.resolution.height/1.3:state.resolution.height>800? state.resolution.width>1644?state.resolution.height/1.55:state.resolution.height/2:state.resolution.height/2.2}}
                />
                
            </div>
            <Modal maskClosable={false}
                    destroyOnClose
                    title="报警处理信息"
                    footer={null}
                    visible={showDealMsgBox}
                    onCancel={() => {
                        setShowDealMsgBox(false)
                    }}>
                    <Input defaultValue={showDealMsg.why || "未知"} addonBefore='报警原因：' onChange={e=>{setShowDealMsg({...showDealMsg,why:e.target.value})}}/>
                    <Input defaultValue={showDealMsg.who || "未知"} addonBefore='处理人员：' disabled={Mode==='local'&&Version==='WZJ'} onChange={e=>{setShowDealMsg({...showDealMsg,who:e.target.value})}}/>
                    <Input defaultValue={showDealMsg.deal || "未知"} addonBefore='处理措施：'onChange={e=>{setShowDealMsg({...showDealMsg,deal:e.target.value})}}/>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                        <div></div>
                        <div>
                            <Button onClick={()=>{
                                http.post("/v1/fixdealalarm", { alarm: [{ id: showData.id, date: showData.alarm_date }], msg: JSON.stringify({
                                    why:showDealMsg.why,
                                    who:showDealMsg.who,
                                    deal:showDealMsg.deal
                                }),sgin }).then(data => {
                                    getAlarmDataS();
                                    setShowDealMsgBox(false)
                                })
                                // http.put('/v1/alarm/'+showData.id,{
                                //     ...showData,
                                //     msg:JSON.stringify({
                                //         why:showDealMsg.why,
                                //         who:showDealMsg.who,
                                //         deal:showDealMsg.deal
                                //     })
                                // }).then(res=>{
                                //     getAlarmDataS();
                                //     setShowDealMsgBox(false)
                                // })
                            }}
                            >修改</Button>
                            <Button onClick={()=>{
                                setShowDealMsgBox(false)
                            }}
                            >关闭</Button>
                        </div>
                    </div>
                </Modal>
                <Modal maskClosable={false}
                    destroyOnClose
                    title="处理报警"
                    footer={null}
                    visible={showDeal}
                    onCancel={() => {
                        setIsDealAlarmMore(false)
                        setShowDeal(false)
                    }}>
                    <Form
                        name="basic"
                        form={form}
                        onFinish={values => {
                            if(isDealAlarmMore){
                                let now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                                let starttime = formatDateTimes(now_date.getTime())
                                let endtime = formatDateTimes(new Date().getTime())
                                if(startTime!==''){
                                    starttime = startTime
                                }
                                if(endTime!==''){
                                    endtime = endTime
                                }
                                let params = { starttime, endtime,type:selAlarmType,msg: JSON.stringify(values) }
                                if(selUser&&selUser!==0){
                                    params = {...params,user:selUser}
                                }
                                if(selDis&&selDis!==''){
                                    params = {...params,district:[selDis]}
                                }
                                
                                if(selAlarmDev&&selAlarmDev!==''){
                                    params = {...params,device:[selAlarmDev]}
                                }
                                if(selDeviceNodeIds.length>0){
                                    params = {...params,node:selDeviceNodeIds}
                                }
                                http.post("/v1/fixdealalarmByType", params,sgin).then(data => {
                                    if (data.code === 0) {
                                        setIsLoading(true);
                                        getAlarmDataS();
                                        setDealEnable(false)
                                        setShowDeal(false)
                                    }
                                })
                                setIsDealAlarmMore(false)
                            }else{
                                http.post("/v1/dealalarms", { alarm: dealList, msg: JSON.stringify(values) },sgin).then(data => {
                                    if (data.code === 0) {
                                        setIsLoading(true);
                                        setSelectedRowKeys([]);
                                        getAlarmDataS();
                                        setDealEnable(false)
                                        setShowDeal(false)
                                    }
                                })
                            }
                        }}
                    >
                        <Form.Item
                            label="报警原因"
                            name="why"
                            rules={[{ required: true, message: '输入报警原因' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="处理人员"
                            name="who"
                            initialValue={Mode==='soc'?'':state.main.name}
                            rules={[{ required: true, message: '输入处理人员' }]}
                        >
                            <Input disabled={Mode==='local'&&Version==='WZJ'} />
                        </Form.Item>
                        <Form.Item
                            label="处理方法"
                            name="deal"
                            rules={[{ required: true, message: '输入处理方法' }]}
                        >
                            <Input.TextArea />
                        </Form.Item>
                    </Form>
                    <Button type="primary" onClick={() => {
                        setDealEnable(true)
                        sginEnable?setShowSgin(true):form.submit()
                    }} disabled={dealEnable}>
                        确定
                    </Button>
                </Modal>
        </div>
    )
}

export default Alarm